module.exports = __webpack_public_path__ + "static/media/image-preview-storygame-pc.f6b304e6.png";